<div class="login">
    <div class="header" [ngClass]="{'unreleased': isUnreleasedDevice}">
        <div class="title-wrapper">
            <div class="title">{{headerTitle}}</div>
            <div class="title-secondary">{{headerTitleSecondary}}</div>
        </div>
        <img [src]="resources.imgs.philips" />
    </div>
    <iframe class="login-frame" #loginIframe [src]="webLoginURL"></iframe>
    <div class="footer" [ngClass]="{'unreleased': isUnreleasedDevice, 'released-medical': !isUnreleasedDevice && !isNonMedicalDevice}">
        <div class="left">
            <ng-container>
                <span class="about" (click)="showAbout=true"><u>About</u></span>
                <span>{{copyrightMessage}}</span>
                <span *ngIf="isNonMedicalDevice">Not for diagnostic, monitoring or therapeutic purposes or in any other manner for regular medical practice.</span>
                <span *ngIf="isUnreleasedDevice">The Workflow Information Management Enterprise Manager (WIP) V{{releaseVersion}} is provided on an “as is” basis without warranty of any kind, including without limitation, the warranty that it is free from defects. No use of the Workflow Information Management Enterprise Manager (WIP) V{{releaseVersion}} is authorized hereunder except under this disclaimer.</span>
            </ng-container>
        </div>
        <div class="right">
            <img class="consult-symbol" [src]="resources.imgs.consultSymbol">
            <a href="https://www.philips.com/IFU" target="_blank">eIFU</a>
            <img class="caution-symbol" [src]="resources.imgs.cautionSymbol" />
            <span *ngIf="isUnreleasedDevice"  class="caution-text" >For evaluation purposes only</span>
        </div>
    </div>
</div>

<em-about *ngIf="showAbout" (onClose)="showAbout=false"></em-about>